<template>
  <div>
    <base-title
      :title="StringLanguage.campaignDetails"
      :subtitle="StringLanguage.EasyPerformance"
      link="easy-performance"
    >
      <base-button
        :text="
          campaign.status !== 'PAUSED' ? 'Pausar campanha' : 'Retomar campanha'
        "
        design="two"
        :class="!!isMobile && 'reverse mb_15 w-100'"
        @click="
          pauseCampaign(
            campaign.name,
            campaign.id,
            campaign.status,
            campaign.configs.type
          )
        "
      />
    </base-title>

    <div class="wrapper">
      <base-box class="details-campaign">
        <div class="campaign-name">
          <i class="fal fa-megaphone" />
          <p>{{ campaign.name }}</p>
        </div>

        <div class="step">
          <p>Tipo de ação</p>
          <p>{{ getActionType(campaign.configs && campaign.configs.type) }}</p>
        </div>

        <div class="step">
          <p>Segmentações</p>
          <div class="tags">
            <div
              class="tag"
              v-for="(segmentation, index) in campaign.segmentation_rules"
              :key="index"
            >
              {{ formatSegmentation(segmentation) }}
            </div>
          </div>
        </div>

        <div class="step">
          <p>Benefício</p>
          <p>
            {{
              formatCupons((campaign.configs && campaign.configs.gift) || {})
            }}
          </p>
        </div>

        <div class="step">
          <p>Formas de envio</p>
          <p>
            {{ campaign.configs && campaign.configs.type_send.toUpperCase() }}
          </p>
        </div>

        <div class="step">
          <p>Mensagem</p>
          <p>
            {{
              formatMessage(
                (campaign.configs && campaign.configs.content) || {}
              )
            }}
          </p>
        </div>

        <div class="step">
          <p>Disparo</p>
          <!-- Dia da semana / Seg - Qua - Sex / 12:30 -->
          <p>
            {{ formatSendTime(campaign.configs && campaign.configs.send_time) }}
          </p>
        </div>
      </base-box>

      <div class="dashboard-campaign">
        <div class="totalizer">
          <div class="card">
            <p class="value">
              {{ Utils.convertMoney(campaign.orderTotal || 0) }}
            </p>
            <p>Valor em Vendas</p>
          </div>
          <div class="card">
            <p class="value">
              {{
                Utils.convertMoney(
                  campaign.orderTotal / (campaign.conversions || 1) || 0
                )
              }}
            </p>
            <p>Ticket Médio</p>
          </div>
        </div>

        <base-box class="infos" :class="{ mb_20: isMobile }">
          <div class="card">
            <p>{{ campaign.sends || 0 }}</p>
            <p>Envios</p>
          </div>
          <div class="line"></div>
          <div class="card">
            <p>{{ campaign.clicks || 0 }}</p>
            <p>Cliques</p>
          </div>
          <div class="line"></div>
          <div class="card">
            <p>{{ campaign.conversions || 0 }}</p>
            <p>Conversões</p>
          </div>
        </base-box>

        <chart-box
          :maskMoney="false"
          style="height: 463px"
          title="Usos por dia"
          type="line"
          :chartData="charData"
          :chartOptions="chartOptions"
        />

        <base-box class="msg-charts">
          <base-message>
            Para ver os gráficos disponíveis, vire seu celular em modo paisagem.
          </base-message>
        </base-box>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import dayjs from 'dayjs';
import BaseButton from '@/components/Button';
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseMessage from '@/components/Message';
import ModulesApi from '@/api/modules/modules';

import ChartBox from '@/containers/ChartBox';
import campaignAPI from '@/api/modules/performance';
import Utils from '@/utils';

const components = {
  BaseButton,
  BaseTitle,
  BaseBox,
  ChartBox,
  BaseMessage,
};

const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];

export default {
  components,
  data() {
    return {
      campaign: [],
      charData: {
        labels: [],
        datasets: [
          {
            data: [],
          },
        ],
      },
      chartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        elements: {
          line: {
            tension: 0,
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxTicksLimit: 5,
              },
            },
          ],
          yAxes: [
            {
              ticks: {},
            },
          ],
        },
        animation: {
          duration: 1000,
        },
      },
      Utils,
    };
  },
  async beforeCreate() {
    this.finishedMount = false;
    const performance = await ModulesApi.getModuleEnvironment();
    if (performance.getData([]).length === 0) {
      this.$router.push({ name: 'pedidos' });
    }

    this.finishedMount = true;
  },
  created() {
    this.getAllCampaign();
  },
  methods: {
    getActionType(value) {
      switch (value) {
        case 'ARD':
          return 'Ação de recorrência de data';
        case 'ARC':
          return 'Ação de recorrência de conversão';
        case 'APA':
          return 'Ação pontual agendada';
        case 'API':
          return 'Ação pontual imediata';
        default:
          return 'Desconhecido';
      }
    },
    pauseCampaign(name, id, status, type) {
      if (status !== 'PAUSED') {
        confirm(`Deseja mesmo pausar a campanha ${name} ?`, (res) => {
          if (!res) return;
          campaignAPI.updateCampaign({ status: 'PAUSED' }, id);
          this.$router.push({ name: 'easy-performance' });
        });
      } else {
        confirm(`Deseja mesmo retornar a campanha ${name} ?`, (res) => {
          if (!res) return;

          const toStatus = {
            ARC: 'ACTIVE',
            ARD: 'ACTIVE',
            APA: 'SCHEDULED',
            API: 'DRAFT',
          };

          campaignAPI.updateCampaign({ status: toStatus[type] || type }, id);
          this.$router.push({ name: 'easy-performance' });
        });
      }
    },
    formatSendTime(sendTime) {
      if (!sendTime) return;

      const e = sendTime;

      const strTime = [];

      if (sendTime.days_week) {
        const DaysString = sendTime.days_week.map((item) => weekDays[item]);
        if (DaysString.length > 0) {
          strTime.push(DaysString.join('/'));
        }
      }

      if (sendTime.days_month) {
        strTime.push(`Todo dia ${sendTime.days_month}`);
      }

      if (sendTime.date_send) {
        strTime.push(sendTime.date_send);
      }

      if (sendTime.time) {
        strTime.push(
          `${`${sendTime.time || ''}`.substring(0, 2).padStart(2, '0')}:${`${
            sendTime.time || ''
          }`
            .substring(2, 4)
            .padStart(2, '0')}`
        );
      }

      return strTime.join('-');
    },
    formatMessage(type) {
      if (Object.keys(type).length === 0) return '';
      const typeSend = Object.keys(type)[0];
      return type[typeSend].message.text;
    },
    formatCupons(e) {
      if (Object.keys(e).length === 0) return '-';
      const cupons = Object.values(e)[0];

      if (cupons.code && cupons.value && cupons.description) {
        return `${cupons.code} -${Utils.convertMoney(cupons.value || 0)} - ${
          cupons.description
        }`;
      }
      if (cupons.code && cupons.value) {
        return `${cupons.code} - ${Utils.convertMoney(cupons.value)}`;
      }
      return '-';
    },
    formatSegmentation(segment) {
      const segmentNames = {
        clientAgeRange: 'Faixa etária',
        clientRegisterTimer: 'Tempo de cadastro',
        clientAverageTicket: 'Ticket médio',
        clientOrderQuantity: 'Quantidade de pedidos',
        clientTotalSpent: 'Total de gastos',
        geographicDistrict: 'Bairro',
        geographicDistance: 'Distância',
        behavioralDaysOff: 'Dias sem pedir',
        behavioralRespondSatisfactionSurvey: 'Responde pesquisa de satisfação',
        behavioralBirthday: 'Responde pesquisa de satisfação',
      };

      const strSegment = [segmentNames[segment.field] || 'Desconhecido'];

      const data = segment.value;

      if (data.min || data.max) {
        strSegment.push(`Entre ${data.min || 0} e ${data.max || 0}`);
      } else if (data.minimum) {
        strSegment.push(`+${data.minimum || 0}`);
      } else if (data.exact) {
        strSegment.push(`${data.exact || 0}`);
      }

      if (data.isLast) {
        const periodEnum =
          data.isLast == 1
            ? { 1: 'dia', 2: 'mês', 3: 'ano' }
            : { 1: 'dias', 2: 'meses', 3: 'anos' };
        strSegment.push(
          `Últimos ${data.isLast || 0} ${periodEnum[`${data.type || '0'}`]}`
        );
      } else {
        strSegment.push(`Todo o período`);
      }

      return strSegment.join(' - ');
    },
    async getAllCampaign() {
      const { name: id } = this.$route.params;
      const response = await campaignAPI.getCampaignDetails(id);
      const campaign = response.getData([]);

      const dataConversion = [];
      const dataLabels = [];

      const funnel = campaign.reports.reduce(
        (total, item) => {
          total.conversions += item.conversions;
          total.clicks += item.clicks;
          total.sends += item.sends;
          total.orders_total += item.orders_total;

          dataConversion.push(item.conversions);
          dataLabels.push(dayjs(item.created_at).format('DD/MM/YY'));

          return total;
        },
        { conversions: 0, sends: 0, clicks: 0, orders_total: 0 }
      );

      this.charData.datasets[0].data = dataConversion;
      this.charData.datasets[0].label = 'Conversões';
      this.charData.labels = dataLabels;

      campaign.conversions = funnel.conversions;
      campaign.clicks = funnel.clicks;
      campaign.sends = funnel.sends;
      campaign.orderTotal = funnel.orders_total;

      this.campaign = campaign;
    },
    changeRoute(routeName, params = {}) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      return this.$router.push({ name: routeName });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>
<style scoped>
.details-campaign .campaign-name {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #20212459;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 5px;
}
.details-campaign .campaign-name i {
  font-size: 21px;
  margin-bottom: 10px;
}

.details-campaign .step {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
}
.details-campaign .step:not(:last-child) {
  border-bottom: 1px solid #8b8b8b33;
}
.details-campaign .step:last-child {
  padding-bottom: 10px;
}
.details-campaign .step p:nth-child(1) {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: var(--label-secondary);
  margin-bottom: 15px;
}
.details-campaign .step p:nth-child(2) {
  color: #aaaaabbf;
  font-size: 12px;
  line-height: 15px;
}
.dashboard-campaign .totalizer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}
.dashboard-campaign .totalizer .card {
  padding: 20px;
  border-radius: 5px;
  background: var(--box);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 5px solid var(--box-up);
}
.dashboard-campaign .totalizer .card .value {
  color: #f5317d;
  font-weight: 900;
  font-size: 23px;
  line-height: 29px;
  margin-bottom: 15px;
}
.dashboard-campaign .totalizer .card p:last-child {
  color: #999999;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
}
.dashboard-campaign .infos {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.dashboard-campaign .infos .card {
  border: 1px solid #51515980;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
}
.dashboard-campaign .infos .card p:nth-child(1) {
  font-weight: 900;
  font-size: 16px;
  line-height: 19px;
  color: #ccccccd9;
}
.dashboard-campaign .infos .card p:nth-child(2) {
  font-size: 12px;
  line-height: 15px;
  color: #999999;
  margin-top: 5px;
}
.dashboard-campaign .infos .line {
  border: none;
  border-bottom: 2px dotted #99999973;
  height: 0px;
  width: 50px;
}
.msg-charts {
  display: none;
}
.tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.tags .tag {
  color: #aaaaabf2;
  font-weight: bold;
  padding: 5px 10px;
  font-size: 10px;
  line-height: 12px;
  border-radius: 7px;
  border: 1px solid #505359;
  margin-bottom: 5px;
  margin-right: 5px;
}

@media screen and (min-width: 992px) {
  .details-campaign {
    width: 20%;
    min-width: 320px;
  }
  .dashboard-campaign {
    width: 80%;
    margin-left: 20px;
  }
  .wrapper {
    display: flex;
  }
}
@media screen and (max-width: 991px) {
  .details-campaign {
    width: 100%;
  }
  .dashboard-campaign {
    margin-left: 0;
    width: 100%;
  }
  .wrapper {
    display: flex;
    flex-direction: column-reverse;
  }
  .filters .tag {
    padding: 5px 10px;
    border-radius: 5px;

    margin-bottom: 5px;
    margin-right: 5px;
  }

  @media screen and (orientation: portrait) {
    .chart {
      opacity: 0;
      position: absolute;
      top: 0;
      width: 0;
      overflow: hidden;
    }
    .msg-charts {
      display: block;
    }
  }
}
</style>
